import moment from "moment";
import modelBaseV2 from "../../model-base-v2.model";

/**
 * Shop Owner Report Model
 * 
 * @author cmc.nttruong1
 */

const ShopOwnerReportModel = {
  getListSites: () => {
    return modelBaseV2.get('/api/site/managed');
  },
  searchShopOwnerReport: (body) => {
    return modelBaseV2.post('/api/report/shop-owner', { body });
  },
  downloadExcel: (body) => {
    const fileName = `Shop_Owner_Report_${moment().format('YYYYMMDDhhmm')}`;
    return modelBaseV2.postDownload('/api/report/shop-owner/export', { body }, fileName);
  }
}
export default ShopOwnerReportModel;